const arrowSticker = `<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" class="stamp-icon" >
<path d="M28.5 14L26.385 16.115L33.255 23H9V26H33.255L26.37 32.885L28.5 35L39 24.5L28.5 14Z" fill="#54585D"/>
</svg>
`;

export default arrowSticker;